function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import React, { useCallback, useEffect, useRef } from 'react';
import { SLModal } from '@yy/sl-admin-components';
import { useTranslation } from '../../_utils/i18n';
import { EBillStatus, EBPayStatus, EPayMethodType, ErrorPrefixKey, PayErrorMap } from '../../constants';
import { useRequest } from 'ahooks';
import { getBillStatus } from '../../services';
import PostMessageEventBus from '../../_utils/PostMessageEventBus';
import usePayMerchantInfo from './hooks/usePayMerchantInfo';
import isEmpty from 'lodash/isEmpty';
import { LoadedEvent, PaymentSDKPayEvent, PaymentSDKPayFailEvent, PaymentSDKRedirectEvent, PaymentSDKWillPayEvent, PaymentSDKWillReadyEvent } from '../../constants/eventBus';
import { postPayPayNow } from '../../services.paynow';
import { getCdnPath } from '../../config/cdn';
var noop = function noop() {};

/**
 * 对 returnUrl 的二次处理
 */
var getPayResultHandler = function getPayResultHandler() {
  var pageResultHandlerPath = "".concat(getCdnPath(window.SETTLEMENT_SDK_ENV), "/pay-result-handler.html");
  return pageResultHandlerPath;
};
var getIframePath = function getIframePath() {
  return "".concat(getCdnPath(window.SETTLEMENT_SDK_ENV), "/shell.html");
};
var ShellModal = function ShellModal(props) {
  var isNeedConfirmBeforeClosing = props.isNeedConfirmBeforeClosing,
    billId = props.billId,
    appId = props.appId,
    bizType = props.bizType,
    subBizType = props.subBizType,
    priceCurrencyCode = props.priceCurrencyCode,
    payChannel = props.payChannel,
    payMethod = props.payMethod,
    _props$onPayCancel = props.onPayCancel,
    onPayCancel = _props$onPayCancel === void 0 ? noop : _props$onPayCancel,
    _props$onPaySuccess = props.onPaySuccess,
    onPaySuccess = _props$onPaySuccess === void 0 ? noop : _props$onPaySuccess,
    closeModal = props.closeModal,
    _props$onAfterClose = props.onAfterClose,
    onAfterClose = _props$onAfterClose === void 0 ? noop : _props$onAfterClose,
    invokeCancelApiOnClose = props.invokeCancelApiOnClose,
    countryCode = props.countryCode,
    billIdInRealTime = props.billIdInRealTime,
    onPayFail = props.onPayFail,
    onSuccess = props.onSuccess,
    env = props.env,
    language = props.language,
    onDirect = props.onDirect,
    phone = props.phone,
    email = props.email;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var iframePath = getIframePath();

  // bizType有值，则代表主站，基参需要保留；bizType没值，则代表非主站，基参不需要再传
  var baseReqParams = React.useMemo(function () {
    return bizType === 'SHOPLINE' ? {
      appId: appId,
      bizType: bizType,
      subBizType: subBizType
    } : {};
  }, [appId, bizType, subBizType]);
  var billStatusPayload = bizType === 'SHOPLINE' ? {
    appId: appId,
    billId: billId,
    bizType: bizType,
    subBizType: subBizType
  } : {
    billId: billId
  };
  var clearTimer = function clearTimer() {
    cancelQueryBillStatus();
  };

  // 是否关闭支付弹窗的时候调用取消的api
  var isInvokeCancelApiOnClose = function isInvokeCancelApiOnClose() {
    if (typeof invokeCancelApiOnClose === 'function') {
      return invokeCancelApiOnClose({
        billId: billId,
        payMethod: EPayMethodType.PayNow
      });
    }
    return false;
  };
  var _useRequest = useRequest(function () {
      return getBillStatus(billStatusPayload);
    }, {
      manual: true,
      pollingInterval: 1000
    }),
    queryBillStatus = _useRequest.runAsync,
    cancelQueryBillStatus = _useRequest.cancel;
  var onCancel = function onCancel() {
    var confirmBeforeClosingResult = isNeedConfirmBeforeClosing();
    if (confirmBeforeClosingResult && billId) {
      var modalIns = SLModal.confirm({
        className: 'confirmModal',
        title: t('settlement.payway.PayNow.box.notice'),
        okText: t('settlement.payway.PayNow.box.notice.btn2'),
        cancelText: t('settlement.payway.PayNow.box.notice.btn1'),
        onCancel: function () {
          var _onCancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            var _response$data;
            var response, status, finallyFn;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return queryBillStatus();
                  case 2:
                    response = _context.sent;
                    status = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.status;
                    finallyFn = noop;
                    if ([EBillStatus.CANCELED, EBillStatus.UNPAID].includes(status)) {
                      finallyFn = onPayCancel;
                    } else {
                      finallyFn = onPaySuccess;
                    }

                    // 关闭当前确认弹窗
                    modalIns.destroy();
                    closeModal();
                    clearTimer();
                    // 执行支付成功 or 取消账单接口
                    finallyFn();
                  case 10:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
          function onCancel() {
            return _onCancel.apply(this, arguments);
          }
          return onCancel;
        }(),
        onOk: function () {
          var _onOk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    // 关闭当前确认弹窗
                    modalIns.destroy();
                    closeModal();
                    clearTimer();
                    onPaySuccess();
                  case 4:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));
          function onOk() {
            return _onOk.apply(this, arguments);
          }
          return onOk;
        }()
      });
    } else {
      closeModal();
      clearTimer();
      onPayCancel === null || onPayCancel === void 0 ? void 0 : onPayCancel({
        invokeCancelApi: isInvokeCancelApiOnClose()
      });
    }
  };

  // 需要与 shell iframe 通讯
  var eventBusRef = useRef(null);
  var iframeRef = useRef(null);
  var _usePayMerchantInfo = usePayMerchantInfo(_objectSpread(_objectSpread({}, baseReqParams), {}, {
      countryCode: countryCode,
      payChannel: payChannel
    })),
    getter = _usePayMerchantInfo.getter,
    payMerchantId = _usePayMerchantInfo.payMerchantId;

  // ShellModal 传入的 returnUrl，统一处理。
  var returnUrl = getPayResultHandler();
  var handleIframeLoaded = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var _yield$getter, payMerchantId;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getter(countryCode);
          case 2:
            _yield$getter = _context3.sent;
            payMerchantId = _yield$getter.payMerchantId;
            if (!(isEmpty(countryCode) || isEmpty(payMethod) || isEmpty(priceCurrencyCode) || !payMerchantId)) {
              _context3.next = 6;
              break;
            }
            return _context3.abrupt("return");
          case 6:
            eventBusRef.current && eventBusRef.current.emit(PaymentSDKWillReadyEvent, _objectSpread(_objectSpread({}, baseReqParams), {}, {
              billId: billId,
              countryCode: countryCode,
              priceCurrencyCode: priceCurrencyCode,
              payMethod: payMethod,
              payChannel: payChannel,
              billIdInRealTime: billIdInRealTime,
              payMerchantId: payMerchantId,
              env: env,
              language: language
            }));
          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [getter, countryCode, payMethod, priceCurrencyCode, billId, payChannel, billIdInRealTime, env, language, baseReqParams]);
  var handleBeforePay = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var finalizedBillId, response, _data, nextAction;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            finalizedBillId = billIdInRealTime || billId || '';
            _context4.prev = 1;
            _context4.next = 4;
            return postPayPayNow(_objectSpread(_objectSpread({}, baseReqParams), {}, {
              billId: finalizedBillId,
              returnUrl: returnUrl,
              region: countryCode,
              channelAppId: payMerchantId,
              phone: phone,
              email: email
            }));
          case 4:
            response = _context4.sent;
            _data = response === null || response === void 0 ? void 0 : response.data; // 支付状态为失败时
            if ((_data === null || _data === void 0 ? void 0 : _data.payStatus) === EBPayStatus.FAILED) {
              onPayFail({
                code: _data === null || _data === void 0 ? void 0 : _data.errorCode,
                msg: PayErrorMap["".concat(_data === null || _data === void 0 ? void 0 : _data.errorCode)] ? t("".concat(ErrorPrefixKey, ".").concat(_data === null || _data === void 0 ? void 0 : _data.errorCode)) : t("".concat(ErrorPrefixKey, ".other")),
                billId: finalizedBillId
              });
            } else {
              // 支付中台正常返回，且返回数据存在payVo时
              // 跟stripe对齐，不用判断payVo字段
              // const nextAction = data?.payVo;
              nextAction = _data === null || _data === void 0 ? void 0 : _data.nextAction; // 存在
              if (nextAction) {
                // 触发 pay 事件
                if (eventBusRef.current) {
                  eventBusRef.current.emit(PaymentSDKPayEvent, nextAction);
                }
              } else if ((_data === null || _data === void 0 ? void 0 : _data.payStatus) === EBPayStatus.SUCCEEDED) {
                // 不存在，且支付状态为成功时
                onSuccess({
                  billId: finalizedBillId,
                  payMethod: payMethod
                });
              }
            }
            _context4.next = 12;
            break;
          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](1);
            onPayFail({
              code: _context4.t0 === null || _context4.t0 === void 0 ? void 0 : _context4.t0.code,
              billId: finalizedBillId
            });
          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 9]]);
  })), [email, billId, billIdInRealTime, countryCode, onPayFail, onSuccess, payMerchantId, payMethod, returnUrl, t, baseReqParams]);

  // 事件监听
  useEffect(function () {
    var _iframeRef$current;
    if ((_iframeRef$current = iframeRef.current) !== null && _iframeRef$current !== void 0 && _iframeRef$current.contentWindow) {
      var win = iframeRef.current.contentWindow;
      if (!eventBusRef.current) {
        eventBusRef.current = new PostMessageEventBus(window, win);
      }
      // 监听 iframe 是否已经加载完毕
      eventBusRef.current.on(LoadedEvent, handleIframeLoaded);
      eventBusRef.current.on(PaymentSDKPayFailEvent, onPayFail);
      eventBusRef.current.on(PaymentSDKWillPayEvent, handleBeforePay);
      eventBusRef.current.on(PaymentSDKRedirectEvent, onDirect);
    }
    return function () {
      if (eventBusRef.current) {
        eventBusRef.current.off(LoadedEvent, handleIframeLoaded);
        eventBusRef.current.off(PaymentSDKPayFailEvent, onPayFail);
        eventBusRef.current.off(PaymentSDKWillPayEvent, handleBeforePay);
        eventBusRef.current.off(PaymentSDKRedirectEvent, onDirect);
      }
    };
  }, [handleBeforePay, handleIframeLoaded, onDirect, onPayFail, onPaySuccess]);
  return /*#__PURE__*/React.createElement(SLModal, {
    width: 1300,
    height: '705px',
    bodyStyle: {
      overflow: 'hidden'
    },
    visible: true,
    centered: true,
    size: "small",
    title: "PayNow",
    okButtonProps: {
      style: {
        display: 'none'
      }
    },
    cancelText: t('settlement.creditbox.cancel'),
    onCancel: onCancel,
    maskClosable: false,
    afterClose: onAfterClose,
    destroyOnClose: true
  }, /*#__PURE__*/React.createElement("iframe", {
    style: {
      width: '100%',
      height: '100%',
      border: 0
    },
    ref: iframeRef,
    title: "PayNow",
    src: iframePath
  }));
};
export default ShellModal;